export default "__VITE_ASSET__CgtxAfb9__"